import services from '@/services/ascentiaServiceIndex'
import {
  FLIGHTAWARE_CONSTS as FAC,
  MAINTENANCE_ISSUES_CONSTS as MIC,
} from '../consts'
import { TIME_TO_LIVE_MINUTE } from '@/utilities/appConsts'

const state = {
  flightAwareLastUpdatedDate: null,
  futureFlightSchedules: [],
}

const getters = {}

const mutations = {
  [FAC.UPDATE_FUTURE_FLIGHT_SCHEDULES]: (state, data) =>
    (state.futureFlightSchedules = data),
  [FAC.UPDATE_LAST_UPDATED_DATE]: (state, data) =>
    (state.flightAwareLastUpdatedDate = data),
}

const actions = {
  async [FAC.GET_FUTURE_FLIGHT_SCHEDULES]({ commit }, params) {
    try {
      const futureFlightSchedules = (
        await services.flightaware.getData(
          'futureFlightSchedules',
          params,
          false,
          TIME_TO_LIVE_MINUTE * 60,
        )
      ).data

      commit(FAC.UPDATE_FUTURE_FLIGHT_SCHEDULES, futureFlightSchedules)
    } catch (error) {
      console.log(`${[FAC.GET_FUTURE_FLIGHT_SCHEDULES]}: error ${error}`)
      commit(`${MIC.NAMESPACE}/${MIC.UPDATE_MX_ERRORS}`, 'upcoming flights', {
        root: true,
      })
    }
  },

  async [FAC.GET_LAST_UPDATED_DATE]({ commit }, params) {
    try {
      const lastUpdatedDate = (
        await services.flightaware.getData(
          'lastUpdatedDate',
          params,
          false,
          TIME_TO_LIVE_MINUTE * 60,
        )
      ).data

      commit(FAC.UPDATE_LAST_UPDATED_DATE, lastUpdatedDate)
    } catch (error) {
      console.log(`${[FAC.GET_LAST_UPDATED_DATE]}: error ${error}`)
      commit(
        `${MIC.NAMESPACE}/${MIC.UPDATE_MX_ERRORS}`,
        'upcoming flights last updated date',
        {
          root: true,
        },
      )
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
